import React from "react";
import { Card } from "antd";

export function Berechnungserklärung() {
  return (
    <>
      <p>
        Unser Tool berechnet den potenziellen Wasserertrag Ihres Daches und
        empfiehlt eine passende Zisternengröße basierend auf folgenden Faktoren:
      </p>
      <ol>
        <li>
          <strong>Dachfläche (in m²):</strong> Die Größe Ihrer Dachfläche
          beeinflusst direkt die Menge an Regenwasser, die gesammelt werden
          kann.
        </li>
        <li>
          <strong>Dachtyp und Abflussbeiwert:</strong>
          <ul>
            <li>
              <strong>Ziegeldach:</strong> Abflussbeiwert von 0,8
            </li>
            <li>
              <strong>Flachdach:</strong> Abflussbeiwert von 0,7
            </li>
            <li>
              <strong>Begrüntes Dach:</strong> Abflussbeiwert von 0,5
            </li>
          </ul>
          Der Abflussbeiwert berücksichtigt Verluste, die bei der Ableitung des
          Regenwassers entstehen können.
        </li>
        <li>
          <strong>Durchschnittlicher Jahresniederschlag (in mm):</strong>{" "}
          Basierend auf historischen Wetterdaten der letzten 10 Jahre für Ihren
          Standort.
        </li>
      </ol>
      <h4>Berechnungsschritte:</h4>
      <ol>
        <li>
          <strong>
            Gesamter jährlicher Niederschlag auf Ihrer Dachfläche (in Litern):
          </strong>
          <br />
          Jährlicher Niederschlag (Liter) = Durchschnittlicher
          Jahresniederschlag (mm) × Dachfläche (m²)
        </li>
        <li>
          <strong>Möglicher Wasserertrag pro Jahr (in Litern):</strong>
          <br />
          Wasserertrag (Liter/Jahr) = Jährlicher Niederschlag (Liter) ×
          Abflussbeiwert
        </li>
        <li>
          <strong>Empfohlene Zisternengröße (in Litern):</strong>
          <br />
          Empfohlene Zisternengröße (Liter) = (Wasserertrag (Liter/Jahr) ÷ 365
          Tage) × 21 Tage
        </li>
      </ol>
      <p>
        <em>Hinweis:</em> 1 mm Niederschlag entspricht 1 Liter Wasser pro
        Quadratmeter Dachfläche.
      </p>
    </>
  );
}

export default Berechnungserklärung;
